import React from 'react';
import {Layout,Divider} from 'antd';
import styles from './layout.module.less';
import wx1 from './wx1.png'
import wx2 from './wx2.png'
import policeLogo from './police_logo.png'
import logo from './logo-white.png'
import history from "../libs/history";

// the hook
import {useTranslation} from 'react-i18next';

export default function () { 
  const {t} = useTranslation();
  return (
    <Layout.Footer style={{padding: 0, background: '#65B1AE'}}>
      <section className={styles.footer}>
        <div className='footer_logo'>
          <img src={logo} alt="" />
        </div>
        <div className='footer_right'>
        <section className='footer_columns'>
          <div className='footer_column'>
            {/* <h2>{t("租赁指南")}</h2> */}
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=cjwt')
              }}>常见问题</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=zllc')
              }}>租赁流程</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=zjzf')
              }}>租金支付</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=kpsm')
              }}>开票说明</a>
            </div>
          </div>
          <div className='footer_column'>
            {/* <h2>{t("售后服务")}</h2> */}
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=fwbz')
              }}>服务标准</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=pcbz')
              }}>赔偿标准</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=thhzc')
              }}>退换货政策</a>
            </div>
          </div>
          <div className='footer_column'>
            {/* <h2>{t("特殊服务")}</h2> */}
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=myjzl')
              }}>免押金租赁</a>
            </div>
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=jl')
              }}>计量</a>
            </div>
          </div>
          <div className='footer_column'>
            {/* <h2>{t("服务协议")}</h2> */}
            <div className='footer_item'>
              <a onClick={() => {
                history.push('/fqa?type=zcxy')
              }}>注册协议</a>
            </div>
          </div>
        </section>
        <div className={styles.right}>
          <div className='wx_item'>
            <img src={wx1} alt=""/>
            <div>官方微信公众号</div>
          </div>
          <div className='wx_item'>
            <img src={wx2} alt=""/>
            <div>官方视频号</div>
          </div>
        </div>
        </div>
      </section>
      <div className={styles.footerLine} />
      <div className={styles.footerBottom}>
        <div className='footer_bottom_item'>服务热线: 400-086-5292 ｜ 021-5169-8879</div>
        <div>Copyright © 2020 - {new Date().getFullYear()}  泉心泉意  版权所有 
          {/* ｜<a target='_blank' href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502007067"> 沪公网安备 31011502007067号</a> */}
          ｜<a target='_blank' href="https://beian.miit.gov.cn/#/Integrated/recordQuery">沪ICP备1704578号</a></div>
        {/* <div style={{width:'350px'}}></div> */}
      </div>
    </Layout.Footer>
  )
}
